function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "tj-logo-full-trademark",
  d: "M630,37.8 C626,37.8 622.8,34.5 622.8,30.5 C622.8,26.5 626,23.2 630,23.2 C634.1,23.2 637.3,26.4 637.3,30.5 C637.3,32.5 636.6,34.3 635.2,35.6 C633.8,37 631.9,37.8 630,37.8 L630,37.8 Z M630,24.9 C626.9,24.9 624.4,27.4 624.4,30.5 C624.4,33.5 626.9,36.1 630,36.1 C633.1,36.1 635.6,33.7 635.6,30.6 C635.6,29.1 635,27.7 634,26.7 C632.9,25.5 631.5,24.9 630,24.9 L630,24.9 Z M633.3,33.9 L631.4,33.9 L630.1,31.2 L629.3,31.2 L629.3,33.9 L627.6,33.9 L627.6,26.9 L630.3,26.9 C632.1,26.9 633.3,27.5 633.3,29 C633.3,29.9 632.8,30.6 632,30.9 L633.3,33.9 L633.3,33.9 Z M629.2,28.3 L629.2,29.8 L630,29.8 C631.2,29.8 631.4,29.6 631.4,29.1 C631.4,28.6 631.2,28.3 630,28.3 L629.2,28.3 L629.2,28.3 Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  className: "tj-logo-full-wordmark",
  transform: "translate(121.000000, 23.000000)"
}, React.createElement("path", {
  d: "M47,0.2 L0.4,0.2 L0.4,12.8 L16.5,12.8 L16.5,66.9 L30.8,66.9 L30.8,12.8 L47,12.8 L47,0.2 Z"
}), React.createElement("path", {
  d: "M63.4,13.5 C48.4,13.5 36.3,25.8 36.3,40.9 C36.3,56 48.4,68.3 63.4,68.3 C78.4,68.3 90.5,56 90.5,40.9 C90.5,25.8 78.4,13.5 63.4,13.5 L63.4,13.5 Z M63.4,55.8 C55.4,55.8 48.9,49.2 48.9,41 C48.9,32.8 55.4,26.2 63.4,26.2 C71.4,26.2 77.9,32.8 77.9,41 C77.9,49.1 71.4,55.8 63.4,55.8 L63.4,55.8 Z"
}), React.createElement("path", {
  d: "M162,18.3 C158.6,15.1 154.2,13.5 149.4,13.5 C143.1,13.5 136.9,17.2 134.4,22.4 C132.2,17.7 127.7,13.5 119.4,13.5 C112.6,13.5 108,17.6 106.7,20.2 L106.6,20.2 L106.6,15.1 L94,15.1 L94,67 L107,67 L107,37.4 C107,31.7 109.1,25.9 116,25.9 C122.5,25.9 124.4,31.2 124.4,36.2 L124.4,67 L137.7,67 L137.7,36.7 C137.7,29.3 142.3,25.9 146.5,25.9 C151.9,25.9 155,29.7 155,36.3 L155,67.1 L168.2,67.1 L168.2,34.7 C168.2,26.2 165.2,21.2 162,18.3 L162,18.3 Z"
}), React.createElement("path", {
  d: "M240.7,18.3 C237.3,15.1 232.9,13.5 228.1,13.5 C221.8,13.5 215.6,17.2 213.1,22.4 C210.9,17.7 206.4,13.5 198.1,13.5 C191.3,13.5 186.7,17.6 185.4,20.2 L185.3,20.2 L185.3,15.1 L172.6,15.1 L172.6,67 L185.7,67 L185.7,37.4 C185.7,31.7 187.8,25.9 194.7,25.9 C201.2,25.9 203.1,31.2 203.1,36.2 L203.1,67 L216.4,67 L216.4,36.7 C216.4,29.3 221,25.9 225.2,25.9 C230.6,25.9 233.7,29.7 233.7,36.3 L233.7,67.1 L246.9,67.1 L246.9,34.7 C246.9,26.2 243.8,21.2 240.7,18.3 L240.7,18.3 Z"
}), React.createElement("path", {
  d: "M273.1,48.9 L260.6,15.1 L246,15.1 L265.6,66.2 L265.8,66.9 L258.7,86.5 L272.4,86.5 L298.6,15.1 L284.7,15.1 L273.1,48.9 Z"
}), React.createElement("path", {
  d: "M334.1,0.2 L334.1,43.7 C334.1,50.4 332.5,54.6 327,54.6 C323.6,54.6 321,53 318.1,50.6 L313.7,63 C316.9,65.8 322.8,68.4 328.2,68.4 C340.9,68.4 348.1,58.9 348.1,45.2 L348.1,0.3 L334.1,0.3 L334.1,0.2 Z"
}), React.createElement("path", {
  d: "M379,13.5 C364,13.5 351.9,25.8 351.9,40.9 C351.9,56 364,68.3 379,68.3 C394,68.3 406.1,56 406.1,40.9 C406.1,25.8 394,13.5 379,13.5 L379,13.5 Z M379,55.8 C371,55.8 364.5,49.2 364.5,41 C364.5,32.8 371,26.2 379,26.2 C387,26.2 393.5,32.8 393.5,41 C393.5,49.1 387,55.8 379,55.8 L379,55.8 Z"
}), React.createElement("path", {
  d: "M435.1,13.5 C430.1,13.5 424.9,16.3 422.7,20 L422.6,20 L422.6,0.2 L409.6,0.2 L409.6,66.9 L422.7,66.9 L422.7,38 C422.7,28.4 429,25.8 432.4,25.8 C436,25.8 442.2,27.4 442.2,38 L442.2,66.9 L455.5,66.9 L455.5,35.7 C455.3,20.5 444.8,13.5 435.1,13.5 L435.1,13.5 Z"
}), React.createElement("path", {
  d: "M485.3,13.5 C480.4,13.5 474.7,16.2 472.5,20.2 L472.4,20.2 L472.4,15.1 L459.7,15.1 L459.7,67 L472.8,67 L472.8,38 C472.8,28.4 479.1,25.8 482.5,25.8 C486.1,25.8 492.3,27.4 492.3,38 L492.3,66.9 L505.6,66.9 L505.6,35.7 C505.5,20.5 495,13.5 485.3,13.5 L485.3,13.5 Z"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  className: "tj-logo-full-icon"
}, React.createElement("rect", {
  x: 44,
  y: 44,
  width: 22,
  height: 44
}), React.createElement("rect", {
  x: 0,
  y: 0,
  width: 66,
  height: 22
}), React.createElement("rect", {
  x: 0,
  y: 44,
  width: 22,
  height: 44
}));

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "tj-logo-full-trademark",
  d: "M510,14.8 C506,14.8 502.8,11.5 502.8,7.5 C502.8,3.5 506,0.2 510,0.2 C514.1,0.2 517.3,3.4 517.3,7.5 C517.3,9.5 516.6,11.3 515.2,12.6 C513.8,14 511.9,14.8 510,14.8 L510,14.8 L510,14.8 Z M510,1.9 C506.9,1.9 504.4,4.4 504.4,7.5 C504.4,10.5 506.9,13.1 510,13.1 C513.1,13.1 515.6,10.7 515.6,7.6 C515.6,6.1 515,4.7 514,3.7 C512.9,2.5 511.5,1.9 510,1.9 L510,1.9 L510,1.9 Z M513.3,10.9 L511.4,10.9 L510.1,8.2 L509.3,8.2 L509.3,10.9 L507.6,10.9 L507.6,3.9 L510.3,3.9 C512.1,3.9 513.3,4.5 513.3,6 C513.3,6.9 512.8,7.6 512,7.9 L513.3,10.9 L513.3,10.9 Z M509.2,5.3 L509.2,6.8 L510,6.8 C511.2,6.8 511.4,6.6 511.4,6.1 C511.4,5.6 511.2,5.3 510,5.3 L509.2,5.3 L509.2,5.3 Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  className: "tj-logo-no-icon-wordmark"
}, React.createElement("path", {
  d: "M47,0.2 L0.4,0.2 L0.4,12.8 L16.5,12.8 L16.5,66.9 L30.8,66.9 L30.8,12.8 L47,12.8 L47,0.2 Z"
}), React.createElement("path", {
  d: "M63.4,13.5 C48.4,13.5 36.3,25.8 36.3,40.9 C36.3,56 48.4,68.3 63.4,68.3 C78.4,68.3 90.5,56 90.5,40.9 C90.5,25.8 78.4,13.5 63.4,13.5 L63.4,13.5 Z M63.4,55.8 C55.4,55.8 48.9,49.2 48.9,41 C48.9,32.8 55.4,26.2 63.4,26.2 C71.4,26.2 77.9,32.8 77.9,41 C77.9,49.1 71.4,55.8 63.4,55.8 L63.4,55.8 Z"
}), React.createElement("path", {
  d: "M162,18.3 C158.6,15.1 154.2,13.5 149.4,13.5 C143.1,13.5 136.9,17.2 134.4,22.4 C132.2,17.7 127.7,13.5 119.4,13.5 C112.6,13.5 108,17.6 106.7,20.2 L106.6,20.2 L106.6,15.1 L94,15.1 L94,67 L107,67 L107,37.4 C107,31.7 109.1,25.9 116,25.9 C122.5,25.9 124.4,31.2 124.4,36.2 L124.4,67 L137.7,67 L137.7,36.7 C137.7,29.3 142.3,25.9 146.5,25.9 C151.9,25.9 155,29.7 155,36.3 L155,67.1 L168.2,67.1 L168.2,34.7 C168.2,26.2 165.2,21.2 162,18.3 L162,18.3 Z"
}), React.createElement("path", {
  d: "M240.7,18.3 C237.3,15.1 232.9,13.5 228.1,13.5 C221.8,13.5 215.6,17.2 213.1,22.4 C210.9,17.7 206.4,13.5 198.1,13.5 C191.3,13.5 186.7,17.6 185.4,20.2 L185.3,20.2 L185.3,15.1 L172.6,15.1 L172.6,67 L185.7,67 L185.7,37.4 C185.7,31.7 187.8,25.9 194.7,25.9 C201.2,25.9 203.1,31.2 203.1,36.2 L203.1,67 L216.4,67 L216.4,36.7 C216.4,29.3 221,25.9 225.2,25.9 C230.6,25.9 233.7,29.7 233.7,36.3 L233.7,67.1 L246.9,67.1 L246.9,34.7 C246.9,26.2 243.8,21.2 240.7,18.3 L240.7,18.3 Z"
}), React.createElement("path", {
  d: "M273.1,48.9 L260.6,15.1 L246,15.1 L265.6,66.2 L265.8,66.9 L258.7,86.5 L272.4,86.5 L298.6,15.1 L284.7,15.1 L273.1,48.9 Z"
}), React.createElement("path", {
  d: "M334.1,0.2 L334.1,43.7 C334.1,50.4 332.5,54.6 327,54.6 C323.6,54.6 321,53 318.1,50.6 L313.7,63 C316.9,65.8 322.8,68.4 328.2,68.4 C340.9,68.4 348.1,58.9 348.1,45.2 L348.1,0.3 L334.1,0.3 L334.1,0.2 Z"
}), React.createElement("path", {
  d: "M379,13.5 C364,13.5 351.9,25.8 351.9,40.9 C351.9,56 364,68.3 379,68.3 C394,68.3 406.1,56 406.1,40.9 C406.1,25.8 394,13.5 379,13.5 L379,13.5 Z M379,55.8 C371,55.8 364.5,49.2 364.5,41 C364.5,32.8 371,26.2 379,26.2 C387,26.2 393.5,32.8 393.5,41 C393.5,49.1 387,55.8 379,55.8 L379,55.8 Z"
}), React.createElement("path", {
  d: "M435.1,13.5 C430.1,13.5 424.9,16.3 422.7,20 L422.6,20 L422.6,0.2 L409.6,0.2 L409.6,66.9 L422.7,66.9 L422.7,38 C422.7,28.4 429,25.8 432.4,25.8 C436,25.8 442.2,27.4 442.2,38 L442.2,66.9 L455.5,66.9 L455.5,35.7 C455.3,20.5 444.8,13.5 435.1,13.5 L435.1,13.5 Z"
}), React.createElement("path", {
  d: "M485.3,13.5 C480.4,13.5 474.7,16.2 472.5,20.2 L472.4,20.2 L472.4,15.1 L459.7,15.1 L459.7,67 L472.8,67 L472.8,38 C472.8,28.4 479.1,25.8 482.5,25.8 C486.1,25.8 492.3,27.4 492.3,38 L492.3,66.9 L505.6,66.9 L505.6,35.7 C505.5,20.5 495,13.5 485.3,13.5 L485.3,13.5 Z"
}));

var _ref7 =
/*#__PURE__*/
React.createElement("rect", {
  x: 44,
  y: 44,
  width: 22,
  height: 44
});

var _ref8 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0,
  y: 0,
  width: 66,
  height: 22
});

var _ref9 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0,
  y: 44,
  width: 22,
  height: 44
});

var SvgTjLogo = function SvgTjLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    className: "tj-logo-wrapper tj-log-svg",
    ref: svgRef
  }, props), React.createElement("svg", _extends({
    className: "tj-logo-full",
    viewBox: "0 0 638 110",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4), React.createElement("svg", _extends({
    className: "tj-logo-wordmark-only",
    viewBox: "0 0 518 87",
    ref: svgRef
  }, props), _ref5, _ref6), React.createElement("svg", _extends({
    className: "tj-logo-icon-only",
    viewBox: "0 0 66 88",
    ref: svgRef
  }, props), _ref7, _ref8, _ref9));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTjLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tj-logo.a746a55b.svg";
export { ForwardRef as ReactComponent };